import {fetchFactorPeriods, fetchFactorTypes, SummaryType} from '@ls/grouping-service';
import {exchange} from '@ls/js-fetch';
import GroupingResult from 'state/Constants/GroupingResult';
import ScaleType from 'state/Constants/ScaleType';
import SelectionState from 'state/selections/SelectionState';
import {selectGetGroupingParams} from 'state/selections/selectors';
import {splitByCalcType} from 'state/util';
import scope from './scope';
import {selectDefinitions} from './selectors';

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});
export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_GRID_DATA = `${scope}/REQUEST_GRID_DATA`;
export const RECEIVE_GRID_DATA = `${scope}/RECEIVE_GRID_DATA`;
export const requestGridData = () => async (dispatch, getState) => {
  const state = getState();
  const definitions = selectDefinitions(SelectionState.COMMITTED)(state);

  if (!definitions?.length) {
    return;
  }
  const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);
  const [absDefinitions, bmkDefinitions, relDefinitions] = splitByCalcType(definitions);

  const request = async (summary, definitions, benchesToo) => {
    dispatch({type: REQUEST_GRID_DATA, summary});

    const resultsGropingParam = [];
    if (definitions.find(def => def.scaleType === ScaleType.WeightedAverage)) {
      resultsGropingParam.push(GroupingResult.SECURITY_LEVEL_ATTRIBUTES_BUCKET)
    }
    if (definitions.find(def => def.scaleType === ScaleType.Contribution)) {
      resultsGropingParam.push(GroupingResult.SECURITY_LEVEL_ATTRIBUTES)
    }

    const params = getGroupingParams({
      summary,
      benchesToo,
      results: resultsGropingParam,
      factrib_factors: [...new Set(definitions.map(({factorType}) => factorType))].join(','),
      factrib_periods: [...new Set(definitions.map(({period}) => period))].join(','),
    });

    dispatch({
      type: RECEIVE_GRID_DATA,
      summary,
      data: (await exchange({
        params,
        cancelId: `data-${scope}-${summary}`,
        url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
      }))?.data,
    });
  };
  if (absDefinitions.length || bmkDefinitions.length) {
    request(
      SummaryType.ABSOLUTE,
      [...absDefinitions, ...bmkDefinitions],
      bmkDefinitions.length > 0,
    ).then()
  }

  if (relDefinitions.length) {
    request(
      SummaryType.RELATIVE,
      relDefinitions,
      true,
    ).then()
  }
};

export const REQUEST_FACTOR_TYPES = `${scope}/REQUEST_FACTOR_TYPES`;
export const RECEIVE_FACTOR_TYPES = `${scope}/RECEIVE_FACTOR_TYPES`;
export const requestFactorTypes = () => async (dispatch) => {
  dispatch({type: REQUEST_FACTOR_TYPES});
  dispatch({
    type: RECEIVE_FACTOR_TYPES,
    data: await fetchFactorTypes()
  });
};

export const REQUEST_FACTOR_PERIODS = `${scope}/REQUEST_FACTOR_PERIODS`;
export const RECEIVE_FACTOR_PERIODS = `${scope}/RECEIVE_FACTOR_PERIODS`;
export const requestFactorPeriods = () => async (dispatch) => {
  dispatch({type: REQUEST_FACTOR_PERIODS});
  dispatch({
    type: RECEIVE_FACTOR_PERIODS,
    data: await fetchFactorPeriods()
  });
};